module.exports = __webpack_public_path__ + "media/images/segment_engineer-e8f776b32464d3e8c315857dd00e385e.svg";